import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { dataTestIds } from 'src/constants/data-test-ids';
import { useChartFields } from '../../../hooks/useChartFields';

export const ReviewOfSystemsContainer: FC = () => {
  const { data: chartFields } = useChartFields({ requestedFields: { ros: { _tag: 'ros' } } });
  const { t } = useTranslation();
  const ros = chartFields?.ros?.text;

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%' }}
      data-testid={dataTestIds.telemedEhrFlow.reviewTabRosContainer}
    >
      <Typography variant="h5" color="primary.dark">
        {t('telemed.review.ros.title')}
      </Typography>
      <Typography>{ros}</Typography>
    </Box>
  );
};
